"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Alert;

var _Alert = require("@adobe/react-spectrum-workflow/dist/Alert");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Alert(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Alert.A4uAlert, null));
}